

/****************************************************************************

  Generated by const.tst - please don't make any changes in this file

****************************************************************************/


    /** Generated from Novabase.SPA.ErrorHandlerConstants **/
	export const ErrorHandlerConstants = { 
		webApiBusinessExceptionStatusCode: 599,
		duplicateKeyErrorCode: 'DuplicateKey',
    
	}


